import { Address, AddressType } from '../../models/Address';
import { ProductBillingRule } from 'src/app/models/productBilling';
import { RMO_PropertyMapping, RMO_Property } from 'src/app/shared-components-module/integrations/models/rentManager';

export class Client {
	constructor(){
		this.addresses = [];
	}
	id: number;
	clientName: string;
	cra: boolean;
	clientId : number;
	billingType: ClientBillingTypes;
	directOrder : boolean;
	manualProcessing : boolean;
	mainContactName: string;
	mainPhone: string;
	fax: string;
	email: string;
	affiliateName: string;
	knownIntegrations: string;
	rentalUnitCount: number;
	totalPropertyCount: number;
	pms: string;
	ownerName: string;
	ownerCompany: string;
	ownerPhone: string;
	ownerEmail: string;
	billingContact: string;
	billingPhone: string;
	billingEmail: string;
	applicantPayDefault: boolean;
	addresses : Address[] = [];
	autoSendAAL : boolean;
  	legacyTazWorksBillingId: string;
  	accessCriminalGrid: boolean;
	enableCriminalGrid: boolean;
	limitedCredentialing : boolean;
	considerLandlordUtilityDebt : boolean;
	landlordDebtDecision : number;
	utilityDebtDecision : number;

	public get clientPhysicalAddress() : Address {
		let addy = this.addresses.find(a => {return a.physical; });
		return addy;
	}

	public get clientBillingAddress() : Address {
		let addy = this.addresses.find(a => {return a.billing; });
		return addy;
	}

	isActive : boolean;
	createdDate: Date;
	lastOrderedDate: Date;
	totalOrders: number;
	prettyCreatedDate: string;
	prettyLastOrderDate : string;
	notes: ClientNote[];
	associatedSalesRep : string;
	accountType : number;
	dba : string;
	packageIds : number[];
	locations : Array<ClientLocation>;
	threshholdsUpdated: boolean;
	billingEntityUCID : string;
	billingEntityCode : string;
}

export class ClientVendorCreds
{
	id: number;
	userName: string;
	password: string;
	clientLocationId: number;
	productName: string;
	makeClientUser : boolean;
}

export class ClientLocationDropDownValue
{
	clientId: number;
	locationName: string;
	clientLocationId: number;
}

export class ClientLocation {
	constructor(){
		this.addresses = [];
	}
	id: number;
	locationName: string;
	clientId: number;
	addressId: number;
	manualProcessing : boolean;
	isClientPhysicalAddress: boolean;
	isClientBillingAddress: boolean;
	propertyAccountNumber: string;
	mainContactName: string;
	mainPhone: string;
	fax: string;
	MaskMainContactNameFromAal: boolean;
	mainContactEmail: string;
	affiliateName: string;
	rentalUnitCount: number;
	ownerName: string;
	ownerCompany: string;
	ownerPhone: string;
	ownerEmail: string;
	billingContact: string;
	billingPhone: string;
	billingEmail: string;
	isActive: boolean;
	creds: ClientVendorCreds;
	addresses : Address[] = [];
	autoSendAALOverride : boolean;
	legacyTazWorksBillingId: string;
	rentToIncomeThreshold : number;
	monthlyPricingEnabled : boolean;
	monthlyPricingAmount : number;
	monthlyPricingReportCount : number;
	autoSendAAL : boolean;
	marketSegmentId: number;
	incomeVerEnabled : boolean;
	incomeVerDocsEnabled : boolean;
	propertyMapping: RMO_Property;

	public get physicalAddress() : Address {
		let addy = this.addresses.find(a => {return a.physical == true; });
		return addy;
	}

	public get billingAddress() : Address {
		let addy = this.addresses.find(a => {return a.billing == true; });
		return addy;
	}
	createdDate: Date;
	lastOrdered: Date;
	totalOrders: number;
	prettyCreatedDate: string;
	prettyLastOrderDate : string
	prettyFirstOrderDate : string
	clientName : string;
	creditOnlyReport : boolean;
	dba: string;
	associatedSalesRep: string;
	knownIntegrations: string;
	pms: string;
	notes: PropertyNote[] = [];
	apiPartner : number;
	conditionalLowVerbiage : string;
	conditionalHighVerbiage : string;
	sendAALWarningsTo : string;
	rmoPropertyAssignmentId: number;
	rmoLocationId : number;
	yardiPropertyAssignmentId: string = "";
	hasExistingPMSMapping: boolean;
	apiPartnerName : string;
	externalBillingCode: string;
	billingEntityUCID : string;
	billingEntityCode : string;
	productBilling : ProductBillingRule[];
	alternativeScoringModels: AlternateScoringModel[];
}
export enum ClientBillingTypes {
	POS = 0,
	Monthly = 1,
}

export enum MarketSegment {

}

export class ClientNote {
	id: number;
	userId: number;
	clientId: number;
	note: string;
	noteType: number;
	createdDate: Date;
	prettyCreatedDate: string;
	creatingUserName: string;
	locationId : number;
}

export class PropertyNote extends ClientNote {
	locationId : number;
}
export class ClientNoteType {
	constructor(id: number, name : string, cls : string){
		this.id = id;
		this.displayName = name;
		this.className = cls;
	}
	id : number;
	displayName : string;
	className: string;
}


export class UserInvitation {
	constructor(){
		this.properties = new Array<ClientLocation>();
	}
	id: number;
	firstName: string;
	lastName: string;
	email: string;
	admin: boolean;
	viewBilling: boolean;
	viewReporting: boolean;
	addProperties: boolean;
	addUsers: boolean;
	canUnmaskPII: boolean;
	startScreenings: boolean;
	setPropertyDecision : boolean;
	clientId: number;
	initiatingUserId: number;
	inviteToken: any;
	properties: ClientLocation[];
}

export class UserInvitationProperties {
	public id: number;
	public userInvitationTokenId: number;
	public clientLocationId: number;
	public userId: number;
}

export class AlternateScoringModel {
	public id: number;
	public clientId: number;
	public scoringModelName: string;
	public recDecAccept: number;
	public recDecConditionalHigh: number;
	public recDecConditionalLow: number;
	public recDecDeny: number;
	public locationDefault: boolean;
	public onCreationScoringModel : boolean;
}

export class ScoringModelLocationAssignment
{
	constructor(modelId: number, locationId: number) {
		this.scoringModelId = modelId;
		this.clientLocationId = locationId;
	}
	public id: number;
	public scoringModelId: number;
	public clientLocationId: number;
	public clientLocationName: string;
	public locationDefault: boolean;
}